import { Container, Header, Panel, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { BRANCH_IO_KEY } from '../../constants';
import AppBadges from '../AppBadges';
import AppSMSInput from '../AppSMSInput';
import styles from './HeroAppDownload.module.css';

const cx = classnames.bind(styles);

export default function HeroAppDownload({ useH1Header }) {
  return (
    <div className={cx('heroImageBackground')}>
      <Container>
        <Panel className={cx('appDownloadContent')} color="white" rounded={false}>
          <Header as={useH1Header ? 'h1' : 'h2'} className={cx('header')} color="midnight">
            GasBuddy App - Find Local Gas Prices, Track Rewards & More!
          </Header>
          <Text as="p" className={cx('subHeader')} color="midnight">
            Over the last 15 years, GasBuddy has saved users over $3.1 billion dollars.
            Download our easy-to-use app to start saving at the pump, unlock exclusive deals and rewards, and complete fun challenges to win free gas today.
          </Text>
          <AppSMSInput branchKey={BRANCH_IO_KEY} />
          <br />
          <AppBadges analyticsScreenName="App_Page" fluid showReviewSections />
        </Panel>
      </Container>
    </div>
  );
}

HeroAppDownload.propTypes = {
  useH1Header: PropTypes.bool,
};

HeroAppDownload.defaultProps = {
  useH1Header: false,
};
